const SUPER_MINTER_ADDRESS = "0x0000000000CF4558c36229ac0026ee16D3aE35Cd";
const SUPER_MINTER_ABI = [
  { inputs: [], name: "CallerNotDelegated", type: "error" },
  { inputs: [], name: "ExceedsMaxPerAccount", type: "error" },
  { inputs: [], name: "ExceedsMintSupply", type: "error" },
  { inputs: [], name: "ExceedsSignedQuantity", type: "error" },
  { inputs: [], name: "InvalidAffiliate", type: "error" },
  { inputs: [], name: "InvalidAffiliateFeeBPS", type: "error" },
  { inputs: [], name: "InvalidMaxMintableRange", type: "error" },
  { inputs: [], name: "InvalidMerkleProof", type: "error" },
  { inputs: [], name: "InvalidMode", type: "error" },
  { inputs: [], name: "InvalidPlatformFeeBPS", type: "error" },
  { inputs: [], name: "InvalidPlatformFeeConfig", type: "error" },
  { inputs: [], name: "InvalidPlatformFlatFee", type: "error" },
  { inputs: [], name: "InvalidSignature", type: "error" },
  { inputs: [], name: "InvalidTimeRange", type: "error" },
  { inputs: [], name: "MaxMintableIsZero", type: "error" },
  { inputs: [], name: "MaxMintablePerAccountIsZero", type: "error" },
  { inputs: [], name: "MerkleRootIsEmpty", type: "error" },
  { inputs: [], name: "MintDoesNotExist", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "blockTimestamp", type: "uint256" },
      { internalType: "uint32", name: "startTime", type: "uint32" },
      { internalType: "uint32", name: "endTime", type: "uint32" }
    ],
    name: "MintNotOpen",
    type: "error"
  },
  { inputs: [], name: "MintPaused", type: "error" },
  { inputs: [], name: "MintsAlreadyExist", type: "error" },
  { inputs: [], name: "NotConfigurable", type: "error" },
  { inputs: [], name: "PlatformFeeAddressIsZero", type: "error" },
  { inputs: [], name: "SignatureAlreadyUsed", type: "error" },
  { inputs: [], name: "SignatureExpired", type: "error" },
  { inputs: [], name: "SignedPriceTooLow", type: "error" },
  { inputs: [], name: "SignerIsZeroAddress", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "paid", type: "uint256" },
      { internalType: "uint256", name: "required", type: "uint256" }
    ],
    name: "WrongPayment",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "uint16", name: "bps", type: "uint16" }
    ],
    name: "AffiliateFeeSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "affiliate", type: "address" },
      { indexed: false, internalType: "uint256", name: "accrued", type: "uint256" }
    ],
    name: "AffiliateFeesWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "bytes32", name: "root", type: "bytes32" }
    ],
    name: "AffiliateMerkleRootSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "platform", type: "address" },
      {
        components: [
          { internalType: "uint96", name: "perTxFlat", type: "uint96" },
          { internalType: "uint96", name: "perMintFlat", type: "uint96" },
          { internalType: "uint16", name: "perMintBPS", type: "uint16" },
          { internalType: "bool", name: "active", type: "bool" }
        ],
        indexed: false,
        internalType: "struct ISuperMinter.PlatformFeeConfig",
        name: "config",
        type: "tuple"
      }
    ],
    name: "DefaultPlatformFeeConfigSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "platform", type: "address" },
      { indexed: false, internalType: "uint96", name: "price", type: "uint96" }
    ],
    name: "GAPriceSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "uint32", name: "value", type: "uint32" }
    ],
    name: "MaxMintablePerAccountSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "uint32", name: "value", type: "uint32" }
    ],
    name: "MaxMintableSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "bytes32", name: "merkleRoot", type: "bytes32" }
    ],
    name: "MerkleRootSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      {
        components: [
          { internalType: "address", name: "edition", type: "address" },
          { internalType: "uint96", name: "price", type: "uint96" },
          { internalType: "uint32", name: "startTime", type: "uint32" },
          { internalType: "uint32", name: "endTime", type: "uint32" },
          { internalType: "uint32", name: "maxMintablePerAccount", type: "uint32" },
          { internalType: "uint32", name: "maxMintable", type: "uint32" },
          { internalType: "uint16", name: "affiliateFeeBPS", type: "uint16" },
          { internalType: "bytes32", name: "affiliateMerkleRoot", type: "bytes32" },
          { internalType: "uint8", name: "tier", type: "uint8" },
          { internalType: "address", name: "platform", type: "address" },
          { internalType: "uint8", name: "mode", type: "uint8" },
          { internalType: "address", name: "signer", type: "address" },
          { internalType: "bytes32", name: "merkleRoot", type: "bytes32" }
        ],
        indexed: false,
        internalType: "struct ISuperMinter.MintCreation",
        name: "creation",
        type: "tuple"
      }
    ],
    name: "MintCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        components: [
          { internalType: "uint32", name: "quantity", type: "uint32" },
          { internalType: "uint256", name: "fromTokenId", type: "uint256" },
          { internalType: "address", name: "allowlisted", type: "address" },
          { internalType: "uint32", name: "allowlistedQuantity", type: "uint32" },
          { internalType: "uint32", name: "signedQuantity", type: "uint32" },
          { internalType: "uint32", name: "signedClaimTicket", type: "uint32" },
          { internalType: "address", name: "affiliate", type: "address" },
          { internalType: "bool", name: "affiliated", type: "bool" },
          { internalType: "uint256", name: "requiredEtherValue", type: "uint256" },
          { internalType: "uint256", name: "unitPrice", type: "uint256" },
          { internalType: "uint256", name: "platformFee", type: "uint256" },
          { internalType: "uint256", name: "platformFlatFee", type: "uint256" },
          { internalType: "uint256", name: "affiliateFee", type: "uint256" }
        ],
        indexed: false,
        internalType: "struct ISuperMinter.MintedLogData",
        name: "data",
        type: "tuple"
      },
      { indexed: true, internalType: "uint256", name: "attributionId", type: "uint256" }
    ],
    name: "Minted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "bool", name: "paused", type: "bool" }
    ],
    name: "PausedSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "platform", type: "address" },
      { indexed: false, internalType: "address", name: "recipient", type: "address" }
    ],
    name: "PlatformFeeAddressSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "platform", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      {
        components: [
          { internalType: "uint96", name: "perTxFlat", type: "uint96" },
          { internalType: "uint96", name: "perMintFlat", type: "uint96" },
          { internalType: "uint16", name: "perMintBPS", type: "uint16" },
          { internalType: "bool", name: "active", type: "bool" }
        ],
        indexed: false,
        internalType: "struct ISuperMinter.PlatformFeeConfig",
        name: "config",
        type: "tuple"
      }
    ],
    name: "PlatformFeeConfigSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "platform", type: "address" },
      { indexed: false, internalType: "uint256", name: "accrued", type: "uint256" }
    ],
    name: "PlatformFeesWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "platform", type: "address" },
      { indexed: false, internalType: "address", name: "signer", type: "address" }
    ],
    name: "PlatformSignerSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "uint96", name: "price", type: "uint96" }
    ],
    name: "PriceSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "address", name: "signer", type: "address" }
    ],
    name: "SignerSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: false, internalType: "uint8", name: "tier", type: "uint8" },
      { indexed: false, internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { indexed: false, internalType: "uint32", name: "startTime", type: "uint32" },
      { indexed: false, internalType: "uint32", name: "endTime", type: "uint32" }
    ],
    name: "TimeRangeSet",
    type: "event"
  },
  { stateMutability: "payable", type: "fallback" },
  {
    inputs: [],
    name: "BPS_DENOMINATOR",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DEFAULT",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DOMAIN_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "GA_TIER",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_AFFILIATE_FEE_BPS",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_PLATFORM_PER_MINT_FEE_BPS",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_PLATFORM_PER_MINT_FLAT_FEE",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_PLATFORM_PER_TX_FLAT_FEE",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINT_TO_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "VERIFY_MERKLE",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "VERIFY_SIGNATURE",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "affiliateFeesAccrued",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint32[]", name: "claimTickets", type: "uint32[]" }
    ],
    name: "checkClaimTickets",
    outputs: [{ internalType: "bool[]", name: "claimed", type: "bool[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "edition", type: "address" },
          { internalType: "uint8", name: "tier", type: "uint8" },
          { internalType: "uint8", name: "scheduleNum", type: "uint8" },
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint32", name: "quantity", type: "uint32" },
          { internalType: "address", name: "allowlisted", type: "address" },
          { internalType: "uint32", name: "allowlistedQuantity", type: "uint32" },
          { internalType: "bytes32[]", name: "allowlistProof", type: "bytes32[]" },
          { internalType: "uint96", name: "signedPrice", type: "uint96" },
          { internalType: "uint32", name: "signedQuantity", type: "uint32" },
          { internalType: "uint32", name: "signedClaimTicket", type: "uint32" },
          { internalType: "uint32", name: "signedDeadline", type: "uint32" },
          { internalType: "bytes", name: "signature", type: "bytes" },
          { internalType: "address", name: "affiliate", type: "address" },
          { internalType: "bytes32[]", name: "affiliateProof", type: "bytes32[]" },
          { internalType: "uint256", name: "attributionId", type: "uint256" }
        ],
        internalType: "struct ISuperMinter.MintTo",
        name: "p",
        type: "tuple"
      }
    ],
    name: "computeMintToDigest",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "edition", type: "address" },
          { internalType: "uint96", name: "price", type: "uint96" },
          { internalType: "uint32", name: "startTime", type: "uint32" },
          { internalType: "uint32", name: "endTime", type: "uint32" },
          { internalType: "uint32", name: "maxMintablePerAccount", type: "uint32" },
          { internalType: "uint32", name: "maxMintable", type: "uint32" },
          { internalType: "uint16", name: "affiliateFeeBPS", type: "uint16" },
          { internalType: "bytes32", name: "affiliateMerkleRoot", type: "bytes32" },
          { internalType: "uint8", name: "tier", type: "uint8" },
          { internalType: "address", name: "platform", type: "address" },
          { internalType: "uint8", name: "mode", type: "uint8" },
          { internalType: "address", name: "signer", type: "address" },
          { internalType: "bytes32", name: "merkleRoot", type: "bytes32" }
        ],
        internalType: "struct ISuperMinter.MintCreation",
        name: "c",
        type: "tuple"
      }
    ],
    name: "createEditionMint",
    outputs: [{ internalType: "uint8", name: "scheduleNum", type: "uint8" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "platform", type: "address" }],
    name: "defaultPlatformFeeConfig",
    outputs: [
      {
        components: [
          { internalType: "uint96", name: "perTxFlat", type: "uint96" },
          { internalType: "uint96", name: "perMintFlat", type: "uint96" },
          { internalType: "uint16", name: "perMintBPS", type: "uint16" },
          { internalType: "bool", name: "active", type: "bool" }
        ],
        internalType: "struct ISuperMinter.PlatformFeeConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "platform", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" }
    ],
    name: "effectivePlatformFeeConfig",
    outputs: [
      {
        components: [
          { internalType: "uint96", name: "perTxFlat", type: "uint96" },
          { internalType: "uint96", name: "perMintFlat", type: "uint96" },
          { internalType: "uint16", name: "perMintBPS", type: "uint16" },
          { internalType: "bool", name: "active", type: "bool" }
        ],
        internalType: "struct ISuperMinter.PlatformFeeConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { internalType: "bytes1", name: "fields", type: "bytes1" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "version", type: "string" },
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "address", name: "verifyingContract", type: "address" },
      { internalType: "bytes32", name: "salt", type: "bytes32" },
      { internalType: "uint256[]", name: "extensions", type: "uint256[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "gaPrice",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "address", name: "affiliate", type: "address" }
    ],
    name: "isAffiliated",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "address", name: "affiliate", type: "address" },
      { internalType: "bytes32[]", name: "affiliateProof", type: "bytes32[]" }
    ],
    name: "isAffiliatedWithProof",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" }
    ],
    name: "mintInfo",
    outputs: [
      {
        components: [
          { internalType: "address", name: "edition", type: "address" },
          { internalType: "uint8", name: "tier", type: "uint8" },
          { internalType: "uint8", name: "scheduleNum", type: "uint8" },
          { internalType: "address", name: "platform", type: "address" },
          { internalType: "uint96", name: "price", type: "uint96" },
          { internalType: "uint32", name: "startTime", type: "uint32" },
          { internalType: "uint32", name: "endTime", type: "uint32" },
          { internalType: "uint32", name: "maxMintablePerAccount", type: "uint32" },
          { internalType: "uint32", name: "maxMintable", type: "uint32" },
          { internalType: "uint32", name: "minted", type: "uint32" },
          { internalType: "uint16", name: "affiliateFeeBPS", type: "uint16" },
          { internalType: "uint8", name: "mode", type: "uint8" },
          { internalType: "bool", name: "paused", type: "bool" },
          { internalType: "bool", name: "hasMints", type: "bool" },
          { internalType: "bytes32", name: "affiliateMerkleRoot", type: "bytes32" },
          { internalType: "bytes32", name: "merkleRoot", type: "bytes32" },
          { internalType: "address", name: "signer", type: "address" },
          { internalType: "bool", name: "usePlatformSigner", type: "bool" }
        ],
        internalType: "struct ISuperMinter.MintInfo",
        name: "info",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "edition", type: "address" }],
    name: "mintInfoList",
    outputs: [
      {
        components: [
          { internalType: "address", name: "edition", type: "address" },
          { internalType: "uint8", name: "tier", type: "uint8" },
          { internalType: "uint8", name: "scheduleNum", type: "uint8" },
          { internalType: "address", name: "platform", type: "address" },
          { internalType: "uint96", name: "price", type: "uint96" },
          { internalType: "uint32", name: "startTime", type: "uint32" },
          { internalType: "uint32", name: "endTime", type: "uint32" },
          { internalType: "uint32", name: "maxMintablePerAccount", type: "uint32" },
          { internalType: "uint32", name: "maxMintable", type: "uint32" },
          { internalType: "uint32", name: "minted", type: "uint32" },
          { internalType: "uint16", name: "affiliateFeeBPS", type: "uint16" },
          { internalType: "uint8", name: "mode", type: "uint8" },
          { internalType: "bool", name: "paused", type: "bool" },
          { internalType: "bool", name: "hasMints", type: "bool" },
          { internalType: "bytes32", name: "affiliateMerkleRoot", type: "bytes32" },
          { internalType: "bytes32", name: "merkleRoot", type: "bytes32" },
          { internalType: "address", name: "signer", type: "address" },
          { internalType: "bool", name: "usePlatformSigner", type: "bool" }
        ],
        internalType: "struct ISuperMinter.MintInfo[]",
        name: "a",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "edition", type: "address" },
          { internalType: "uint8", name: "tier", type: "uint8" },
          { internalType: "uint8", name: "scheduleNum", type: "uint8" },
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint32", name: "quantity", type: "uint32" },
          { internalType: "address", name: "allowlisted", type: "address" },
          { internalType: "uint32", name: "allowlistedQuantity", type: "uint32" },
          { internalType: "bytes32[]", name: "allowlistProof", type: "bytes32[]" },
          { internalType: "uint96", name: "signedPrice", type: "uint96" },
          { internalType: "uint32", name: "signedQuantity", type: "uint32" },
          { internalType: "uint32", name: "signedClaimTicket", type: "uint32" },
          { internalType: "uint32", name: "signedDeadline", type: "uint32" },
          { internalType: "bytes", name: "signature", type: "bytes" },
          { internalType: "address", name: "affiliate", type: "address" },
          { internalType: "bytes32[]", name: "affiliateProof", type: "bytes32[]" },
          { internalType: "uint256", name: "attributionId", type: "uint256" }
        ],
        internalType: "struct ISuperMinter.MintTo",
        name: "p",
        type: "tuple"
      }
    ],
    name: "mintTo",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "name_", type: "string" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" }
    ],
    name: "nextScheduleNum",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "address", name: "collector", type: "address" }
    ],
    name: "numberMinted",
    outputs: [{ internalType: "uint32", name: "", type: "uint32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "platformFeeAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "platform", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" }
    ],
    name: "platformFeeConfig",
    outputs: [
      {
        components: [
          { internalType: "uint96", name: "perTxFlat", type: "uint96" },
          { internalType: "uint96", name: "perMintFlat", type: "uint96" },
          { internalType: "uint16", name: "perMintBPS", type: "uint16" },
          { internalType: "bool", name: "active", type: "bool" }
        ],
        internalType: "struct ISuperMinter.PlatformFeeConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "platformFeesAccrued",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "platformSigner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint16", name: "bps", type: "uint16" }
    ],
    name: "setAffiliateFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "bytes32", name: "root", type: "bytes32" }
    ],
    name: "setAffiliateMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint96", name: "perTxFlat", type: "uint96" },
          { internalType: "uint96", name: "perMintFlat", type: "uint96" },
          { internalType: "uint16", name: "perMintBPS", type: "uint16" },
          { internalType: "bool", name: "active", type: "bool" }
        ],
        internalType: "struct ISuperMinter.PlatformFeeConfig",
        name: "c",
        type: "tuple"
      }
    ],
    name: "setDefaultPlatformFeeConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint96", name: "price", type: "uint96" }],
    name: "setGAPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint32", name: "value", type: "uint32" }
    ],
    name: "setMaxMintable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint32", name: "value", type: "uint32" }
    ],
    name: "setMaxMintablePerAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "bytes32", name: "merkleRoot", type: "bytes32" }
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "bool", name: "paused", type: "bool" }
    ],
    name: "setPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "recipient", type: "address" }],
    name: "setPlatformFeeAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint8", name: "tier", type: "uint8" },
      {
        components: [
          { internalType: "uint96", name: "perTxFlat", type: "uint96" },
          { internalType: "uint96", name: "perMintFlat", type: "uint96" },
          { internalType: "uint16", name: "perMintBPS", type: "uint16" },
          { internalType: "bool", name: "active", type: "bool" }
        ],
        internalType: "struct ISuperMinter.PlatformFeeConfig",
        name: "c",
        type: "tuple"
      }
    ],
    name: "setPlatformFeeConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "signer", type: "address" }],
    name: "setPlatformSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint96", name: "price", type: "uint96" }
    ],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "address", name: "signer", type: "address" }
    ],
    name: "setSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint32", name: "startTime", type: "uint32" }
    ],
    name: "setStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint32", name: "startTime", type: "uint32" },
      { internalType: "uint32", name: "endTime", type: "uint32" }
    ],
    name: "setTimeRange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint32", name: "quantity", type: "uint32" }
    ],
    name: "totalPriceAndFees",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "total", type: "uint256" },
          { internalType: "uint256", name: "subTotal", type: "uint256" },
          { internalType: "uint256", name: "unitPrice", type: "uint256" },
          { internalType: "uint256", name: "platformFee", type: "uint256" },
          { internalType: "uint256", name: "platformFlatFee", type: "uint256" },
          { internalType: "uint256", name: "platformTxFlatFee", type: "uint256" },
          { internalType: "uint256", name: "platformMintFlatFee", type: "uint256" },
          { internalType: "uint256", name: "platformMintBPSFee", type: "uint256" },
          { internalType: "uint256", name: "affiliateFee", type: "uint256" }
        ],
        internalType: "struct ISuperMinter.TotalPriceAndFees",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "uint8", name: "tier", type: "uint8" },
      { internalType: "uint8", name: "scheduleNum", type: "uint8" },
      { internalType: "uint32", name: "quantity", type: "uint32" },
      { internalType: "uint96", name: "signedPrice", type: "uint96" }
    ],
    name: "totalPriceAndFeesWithSignedPrice",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "total", type: "uint256" },
          { internalType: "uint256", name: "subTotal", type: "uint256" },
          { internalType: "uint256", name: "unitPrice", type: "uint256" },
          { internalType: "uint256", name: "platformFee", type: "uint256" },
          { internalType: "uint256", name: "platformFlatFee", type: "uint256" },
          { internalType: "uint256", name: "platformTxFlatFee", type: "uint256" },
          { internalType: "uint256", name: "platformMintFlatFee", type: "uint256" },
          { internalType: "uint256", name: "platformMintBPSFee", type: "uint256" },
          { internalType: "uint256", name: "affiliateFee", type: "uint256" }
        ],
        internalType: "struct ISuperMinter.TotalPriceAndFees",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "version",
    outputs: [{ internalType: "string", name: "version_", type: "string" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "affiliate", type: "address" }],
    name: "withdrawForAffiliate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "platform", type: "address" }],
    name: "withdrawForPlatform",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  { stateMutability: "payable", type: "receive" }
];

export { SUPER_MINTER_ABI, SUPER_MINTER_ADDRESS };
